import Component from "../../../../js/assets/component.js"

class ButonLpDetailBlock extends Component {
  constructor(el, blockIndex){
    super(el)
    this.$data.blockIndex = blockIndex
  }

  data(){
    return {
      "blockIndex": null
    }
  }

  changed(){
    return {
      "blockIndex": (index, prev)=>{
        if(index===null){
          this.inActivate()
        }else{
          this.activate()
        }
      }
    }
  }

  activate(){
    this.$el.addClass("-active")
  }

  inActivate(){
    this.$el.removeClass("-active")
  }

  mounted() {

  }
}

export default ButonLpDetailBlock
